import i18next from 'i18next'
import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {appSelector, setJbpDetail} from '../../../../../redux/slices/appSlices'

export const InputPurchasePrice = () => {
  const {t} = useTranslation()
  const {jbpDetail: jbp} = useAppSelector(appSelector)
  const dispatch = useAppDispatch()

  const handleChange = (value: string) => {
    dispatch(setJbpDetail({...jbp, price: Number(value)}))
  }

  return (
    <Form.Group className='w-100 mb-4' controlId='formBasicEmail'>
      <Form.Label>{t('Purchase Price')}</Form.Label>
      <Form.Control
        size='sm'
        type='text'
        placeholder={t('Purchase Price')}
        disabled
        value={
          i18next.language === 'en'
            ? 'Rp' + ((jbp?.price as number) ?? 0).toLocaleString('en', {maximumFractionDigits: 4})
            : 'Rp' + ((jbp?.price as number) ?? 0).toLocaleString('id', {maximumFractionDigits: 4})
        }
        onChange={(e: any) => handleChange(e.target.value)}
      />
    </Form.Group>
  )
}
